module.exports = __webpack_public_path__ + "static/media/fpga.4be70491.jpg";